if( !jQuery.trim( $('.menu-subcollection').html() ).length ) {
  jQuery('.content-subcollection .title-parent-sub').addClass('no-subcollection');
}else {
  jQuery('.content-subcollection .title-parent-sub').removeClass('no-subcollection');
}
$(".grid-item.grid-product").each(function() {
  	var h_image = $(this).find('.icon-wish').offset().top - $(this).find('.grid-item__link').offset().top;
  	$(this).find('.zoomywishid').css('top',h_image+'px');
});

var atrvideoid = $('.lite-youtube').attr("videoid");
$( ".lite-youtube" ).replaceWith( "<lite-youtube videoid='"+ atrvideoid +"'></lite-youtube>" );

$(window).resize(function(){
  $(".grid-item.grid-product").each(function() {
     var h_image = $(this).find('.icon-wish').offset().top - $(this).find('.grid-item__link').offset().top;
     $(this).find('.zoomywishid').css('top',h_image+'px');
  });
});
/*chatbecon*/
document.addEventListener("DOMContentLoaded", () => {
  const beacon = document.querySelector("#beacon");

  beacon.addEventListener("touchstart", (e) => {
    loadBeacon();
  },{ passive: true });

  beacon.addEventListener("click", (e) => {
    beacon.classList.add("bea-loading");
    loadBeacon();
    window.Beacon("open");
    beacon.style.zIndex = 1000;
   });

  function loadBeacon() {
    
    if (typeof window.Beacon == "undefined") {
      
      var script = document.createElement("script");
      script.id = "beacon";
      script.text = `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`;
      document.head.appendChild(script);
	  window.Beacon("init", "cae1c2f2-5566-4b84-a98f-f8ca2bd2e5a3");
	  
    }
    
  }

});

/*Endchat becon*/

/*Remove option Filter collection page*/
$('.collection-filter__sort #SortBy option').each(function() {
  if ( $(this).val() == 'created-descending'|| $(this).val() == 'created-ascending'  || $(this).val() == 'price-descending' || $(this).val() == 'price-ascending' || $(this).val() == 'best-selling') {
        $(this).remove();
    }
  if($(this).val() == 'manual') {
     $(this).text('Popularity');
  }
});
/*End Remove option Filter collection page*/

if($('.carousel-custom').length) {
  $('.carousel-custom .arrow').click(function() {
      var slideContainerEl = $(this).parents('.carousel-custom').find('.slide-container');
      var slideEl = $(this).parents('.carousel-custom').find('.slide');
      var slideWidth = slideEl.width();
      $(window).on("resize", function(){
        slideWidth = slideEl.width();
      });
      var maxScrollLeft = slideContainerEl[0].scrollWidth - slideContainerEl.width();
      var position = 0;
      var width = 0;
      var arg = $(this).data("arrow");
      if (arg === "forward") {
          width = slideContainerEl.scrollLeft() + parseInt(slideWidth) ;
          position = width <= maxScrollLeft ? width : 0;
      } else if (arg === "backward") {
          width = slideContainerEl.scrollLeft() - parseInt(slideWidth);
          position = width >= 0 ? width : maxScrollLeft;
      }
      slideContainerEl.scrollLeft(position);
   });
  $(".slide-indicator:first-child").addClass('active');
  $(".carousel-custom .slide-indicator").click(function() { 
      var slideIndex = $(this).data("slideindex");
      var slideContainerEl = $(this).parents('.carousel-custom').find('.slide-container');
      var slideEl = jQuery(this).parents('.carousel-custom').find('.slide');
      var slideWidth = slideEl.width();
      $(window).on("resize", function(){
        slideWidth = slideEl.width();
      });
      var position = slideIndex * (slideWidth);
      slideContainerEl.scrollLeft(position);
  });
  var down =0;
  var up =0;
  $(".move-slide").mousedown(function(event){
      down = parseInt(event.pageX);
  });
  $(".slide-container").on("scroll",function(){ 
      var position = $(this).scrollLeft() / $(this).width();
      $(".slide-indicator").removeClass('active');
      $('*[data-slideindex="'+ position.toFixed() +'"]').addClass("active")
  });  
  $(".move-slide").mouseup(function(event) {
      var slideContainerEl = jQuery(this).parents('.carousel-custom').find('.slide-container');
      var slideEl = jQuery(this).parents('.carousel-custom').find('.slide');
      var slideWidth = slideEl.width();
      jQuery(window).on("resize", function(){
        slideWidth = slideEl.width();
      });
      var maxScrollLeft = slideContainerEl[0].scrollWidth - slideContainerEl.width();
      var position = 0;
      var width = 0;
      up = parseInt(event.pageX);
      if(down > up) {
         width = slideContainerEl.scrollLeft() + parseInt(slideWidth);
         position = width <= maxScrollLeft ? width : 0;
         slideContainerEl.scrollLeft(position);
      }
      if(down < up) {
         width = slideContainerEl.scrollLeft() - parseInt(slideWidth);
         position = width >= 0 ? width : maxScrollLeft;
         slideContainerEl.scrollLeft(position);
      }
  });
}
/*Newletter*/
 $(document).ready(function() {
    if (window.location.href.indexOf("prospect%2Cnewsletter&form_type=customer") > -1) {
      $(".note--success").addClass("old-subscriber-true");
    }
    else {
    $(".note--success").removeClass("old-subscriber-true");
    }
  });
jQuery(function() {
          var rprice = $('.product-block--price .product__price').html();
          $('.atc-price').html(rprice);
          $('.variant-input').on('click', function(){
            setTimeout(function(){ 
              var rprice = $('.product-block--price .product__price').html();
              var sprice = $('.product-block--price .product__price').html();
             var priceNumR = parseFloat(rprice.substring(1));
              var priceNumS = parseFloat(sprice.substring(1));
              
              if(priceNumR > priceNumS){
                $('.atc-price').html(sprice);
              }else{
                $('.atc-price').html(rprice);
              }
             
            }, 1);
          });
        });
 